/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseCommandResult } from '../../models/base-command-result';
import { DeleteKpiCommand } from '../../models/delete-kpi-command';

export interface ApiKpIsDeleteKpiDelete$Plain$Params {
      body?: DeleteKpiCommand
}

export function apiKpIsDeleteKpiDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiKpIsDeleteKpiDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpIsDeleteKpiDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseCommandResult>;
    })
  );
}

apiKpIsDeleteKpiDelete$Plain.PATH = '/api/KPIs/DeleteKPI';
